exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._1BTUYLoJ4aktjlWVzGqMir{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}._3xxOkr3YR8UKvTZZrjlKTS{-webkit-box-flex:1;-webkit-flex:1;-moz-box-flex:1;-ms-flex:1;flex:1}._3xxOkr3YR8UKvTZZrjlKTS:not(:last-child) ._7CI6N2H2PTG8IKuVwK-3R{border-right:none}._7CI6N2H2PTG8IKuVwK-3R{-webkit-border-radius:0;-moz-border-radius:0;border-radius:0;min-width:0;width:100%}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"MarkAttendanceButtons": "_1BTUYLoJ4aktjlWVzGqMir",
	"MarkAttendanceButtons_buttonContainer": "_3xxOkr3YR8UKvTZZrjlKTS",
	"MarkAttendanceButtons_button": "_7CI6N2H2PTG8IKuVwK-3R"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/build-omni-operation-ui_develop/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/Attendance/MarkAttendance/MarkAttendanceButtons/style.postcss
// module id = 1315
// module chunks = 0